import React, { useState } from 'react';
import { Config } from '../.env.js';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import "./style.css";

const InviteForm = () => {
    const navigate = useNavigate();
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${Config.API_URL}/api/invite`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userName, email, role })
            });

            const result = await response.json();

            if (!response.ok) {
                // Show error from backend
                toast.error(result.error || 'Failed to invite user');
                setLoading(false);
                return;
            }

            // Success flow
            setUserName('');
            setEmail('');
            setRole('');
            toast.success('User invited successfully');
            // Optionally: navigate somewhere
        } catch (error) {
            console.error('Error inviting user:', error);
            toast.error('Server error while inviting user');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='has-text-centered'>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className='field'>
                    <label className='label' style={{ marginRight: "246px" }}>Name</label>
                    <div className='control'>
                        <input
                            className='input is-rounded'
                            type='text'
                            placeholder='User Name'
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            style={{ width: '300px' }}
                        />
                    </div>
                </div>

                <div className='field'>
                    <label className='label' style={{ marginRight: "246px" }}>Email Id</label>
                    <div className='control has-icons-right'>
                        <input
                            className='input is-rounded'
                            type='text'
                            placeholder='Email ID'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{ width: '300px' }}
                        />
                    </div>
                </div>

                <div className='field'>
                    <label className='label' style={{ marginRight: "271px" }}>Role</label>
                    <div className='control'>
                        <div className='select'>
                            <select
                                style={{ borderRadius: '20px', width: "300px" }}
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                            >
                                <option value=''>Select Role</option>
                                <option value='Admin'>Admin</option>
                                <option value='Lead'>Lead</option>
                                <option value='Campaign_Manger'>Manager</option>
                                <option value='Pyment_Approver'>Approver</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className='field'>
                    <div className='control'>
                        <button
                            className='button is-primary is-rounded'
                            style={{ width: "300px" }}
                            disabled={!userName || !email || !role || loading}
                        >
                            {loading ? (
                                <div className="loader"></div>
                            ) : (
                                'Invite'
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default InviteForm;
